export default ".overlayWhite {\n  display: none;\n}\n"